import type {
  PublicProfileResponse,
  PublicProfilePageResponse,
  ScreenNameCheckResponse,
  PaginatedFollowersResponse,
  PaginatedFollowingResponse,
  PaginatedFavoritesResponse,
} from '@mrb91002/shared-types'

import { API_BASE } from '../config'

export async function fetchUserProfilePage(screenName: string): Promise<PublicProfilePageResponse> {
  const resp = await fetch(`${API_BASE}/profile-page/${encodeURIComponent(screenName)}`)
  if (!resp.ok) throw new Error('Failed to fetch user profile page')
  return resp.json() as Promise<PublicProfilePageResponse>
}

export async function fetchUserProfileById(identityId: string): Promise<PublicProfileResponse> {
  const resp = await fetch(`${API_BASE}/user-profiles/by-id/${encodeURIComponent(identityId)}`)
  if (!resp.ok) {
    const error = new Error('Failed to fetch user profile by ID') as Error & { status: number }
    error.status = resp.status
    throw error
  }
  return resp.json() as Promise<PublicProfileResponse>
}

export async function fetchUserProfileByScreenName(screenName: string): Promise<PublicProfileResponse> {
  const resp = await fetch(`${API_BASE}/user-profiles/by-screen-name/${encodeURIComponent(screenName)}`)
  if (!resp.ok) throw new Error('Failed to fetch user profile by screen name')
  return resp.json() as Promise<PublicProfileResponse>
}

export async function checkUsernameAvailable(screenName: string): Promise<ScreenNameCheckResponse> {
  const resp = await fetch(`${API_BASE}/public/check-username?screen_name=${encodeURIComponent(screenName)}`)
  if (!resp.ok) throw new Error('Failed to check screen name availability')
  return resp.json() as Promise<ScreenNameCheckResponse>
}

export async function fetchUserFavoritesPaginated(
  screenName: string,
  lastKey: string | null = null,
): Promise<PaginatedFavoritesResponse> {
  let url = `${API_BASE}/user-favorites/${encodeURIComponent(screenName)}`
  if (lastKey) url += `?lastKey=${encodeURIComponent(lastKey)}`
  const resp = await fetch(url)
  if (!resp.ok) throw new Error('Failed to fetch user favorite patterns (paginated)')
  return resp.json() as Promise<PaginatedFavoritesResponse>
}

export async function fetchUserFollowersPaginated(
  screenName: string,
  lastKey: string | null = null,
): Promise<PaginatedFollowersResponse> {
  let url = `${API_BASE}/user-followers/${encodeURIComponent(screenName)}`
  if (lastKey) url += `?lastKey=${encodeURIComponent(lastKey)}`
  const resp = await fetch(url)
  if (!resp.ok) throw new Error('Failed to fetch user followers (paginated)')
  return resp.json() as Promise<PaginatedFollowersResponse>
}

export async function fetchUserFollowingPaginated(
  screenName: string,
  lastKey: string | null = null,
): Promise<PaginatedFollowingResponse> {
  let url = `${API_BASE}/user-following/${encodeURIComponent(screenName)}`
  if (lastKey) url += `?lastKey=${encodeURIComponent(lastKey)}`
  const resp = await fetch(url)
  if (!resp.ok) throw new Error('Failed to fetch user following (paginated)')
  return resp.json() as Promise<PaginatedFollowingResponse>
}
